<script lang="ts">
  import type { Snippet } from 'svelte'
  import Tooltip from '../../../../components/tooltip/Tooltip.svelte'
  import IconButton from '../../../../components/icon-button/IconButton.svelte'
  import type { Icon } from '@lucide/svelte'

  type Props = {
    title: string
    buttonIcon?: typeof Icon
    buttonOnClick?: () => void
    buttonTooltip?: string
    children: Snippet
  }

  const {
    title,
    buttonOnClick,
    buttonIcon: ButtonIcon,
    buttonTooltip,
    children,
  }: Props = $props()
</script>

<div class="container">
  <div class="head">
    <h3 class="title">{title}</h3>

    {#if buttonOnClick && ButtonIcon}
      <Tooltip title={buttonTooltip || ''}>
        <IconButton onclick={buttonOnClick}>
          <ButtonIcon />
        </IconButton>
      </Tooltip>
    {/if}
  </div>

  <div class="content">
    {@render children()}
  </div>
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;

    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.25rem;

      .title {
        font-weight: 600;
        font-size: 1rem;
        line-height: 100%;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
    }
  }
</style>
